import RestModel from './RestModel';
import config from '../config/config.json';
import translate from '../helpers/translateHelper';

const resourceName = 'collector-item-types';

export default {
    list: () => RestModel.list(`${resourceName}/${config.defaultLocale}`).then(l => l.map(i => translate(i)))
};
